import React, { useState } from 'react';

function AnimeCard({ item, onSelect }) {
  const [imgError, setImgError] = useState(false);
  const hasPoster = item.Poster && item.Poster !== 'N/A' && !imgError;

  return (
    <div className="anime-card" onClick={() => onSelect(item.imdbID)}>
      {hasPoster ? (
        <img
          className="anime-card-poster"
          src={item.Poster}
          alt={item.Title}
          loading="lazy"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="anime-card-poster-placeholder">🎌</div>
      )}

      <div className="anime-card-info">
        <p className="anime-card-title">{item.Title}</p>
        <div className="anime-card-meta">
          {item.Year && (
            <span className="badge badge-year">
              {item.Year.slice(0, 4)}
            </span>
          )}
          {item.imdbRating && item.imdbRating !== 'N/A' && (
            <span className="badge badge-rating">
              ★ {item.imdbRating}
            </span>
          )}
          {item.Genre && (
            <span className="badge">
              {item.Genre.split(',')[0].trim()}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default AnimeCard;